import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const SPOTS_TAKEN = 71;
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[4.5rem] flex-col items-center rounded-2xl bg-cream-200/70 px-3 py-3 sm:w-20" data-id="element-27" data-mp="3dugy4td04i5u">
      <span className="font-display text-3xl font-bold tabular-nums text-ember-500" data-id="element-28" data-mp="39rkaupcinxvk">{value}</span>
      <span className="mt-1 text-[0.6rem] font-bold uppercase tracking-[0.14em] text-forest-700/85" data-id="element-29" data-mp="3nrd16jk4sc30">
        {label}
      </span>
    </div>;
}
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 57 * 60 + 10);
  return <section className="w-full bg-cream-100 px-6 pb-12 pt-4 sm:pb-14" aria-labelledby="cuenta-titulo" data-id="element-30" data-mp="3silalflgnxg6">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center" data-id="element-31" data-mp="acyuky49hxb8">
        <h2 id="cuenta-titulo" className="font-display text-3xl font-bold text-forest-800 sm:text-4xl" data-id="element-32" data-mp="5ef3ykeq3xcj">
          Tu Aula Puede Estar Lista Hoy
        </h2>

        <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-cream-200 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-forest-700" data-id="element-33" data-mp="1dnkssfv2qi66">
          <FlameIcon className="h-3.5 w-3.5 text-ember-500" aria-hidden="true" data-id="element-34" data-mp="1njxrjs5h7m7s" />
          Precio de lanzamiento · Cierra en
        </span>

        <div className="mt-6 flex justify-center gap-3" role="timer" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-35" data-mp="1sklg8768fqyu">
          <TimeBlock value={hours} label="Horas" data-id="element-36" data-mp="21jgs9zvyjva2" />
          <TimeBlock value={minutes} label="Min" data-id="element-37" data-mp="21hvu80afpu7g" />
          <TimeBlock value={seconds} label="Seg" data-id="element-38" data-mp="26af6mtxdyjao" />
        </div>

        <p className="mt-4 text-sm text-forest-700/85" data-id="element-39" data-mp="26d1hb2fkpex4">
          Después sube. No vuelve al precio de lanzamiento.
        </p>

        <div className="mt-6 w-full max-w-md text-left" data-id="element-40" data-mp="2g9eggftw0kz9">
          <div className="flex items-baseline justify-between text-xs font-semibold" data-id="element-41" data-mp="2g6s31zkbfb94">
            <span className="text-forest-700/85" data-id="element-42" data-mp="2kapz21ecg5xy">Cupos al precio de lanzamiento</span>
            <span className="text-ember-500" data-id="element-43" data-mp="l681djt7x8ak">{SPOTS_TAKEN}% tomados</span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-cream-300" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={SPOTS_TAKEN} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-44" data-mp="g7wrj92xaxsc">
            <div className="h-full rounded-full bg-ember-500" style={{
            width: `${SPOTS_TAKEN}%`
          }} data-id="element-45" data-mp="p60bi0y9fmi1" />
          </div>
          <p className="mt-2 text-center text-xs text-forest-700/85" data-id="element-46" data-mp="yxd44urvugp4">Quedan pocos cupos disponibles.</p>
        </div>
      </div>
    </section>;
}